export enum LanguageLocaleKey {
  DE = 'de-DE',
  EN_AU = 'en-AU',
  EN_CA = 'en-CA',
  EN_GB = 'en-GB',
  EN_US = 'en-US',
  FR_CA = 'fr-CA',
  ES = 'es',
  JA_JP = 'ja-JP',
  ZH_CN = 'zh-CN',
}

export interface ILanguage {
  name: string;
  value: LanguageLocaleKey;
  flagClassNames: string;
  icon: string;
  firstDayOfTheWeek: number;
}

const languages: ILanguage[] = [
  {
    name: 'Deutsch',
    value: LanguageLocaleKey.DE,
    flagClassNames: 'flag-icon flag-icon-de',
    icon: '/assets/images/flags/de.svg',
    firstDayOfTheWeek: 1,
  },
  {
    name: 'English (Australia)',
    value: LanguageLocaleKey.EN_AU,
    flagClassNames: 'flag-icon flag-icon-au',
    icon: '/assets/images/flags/au.svg',
    firstDayOfTheWeek: 1,
  },
  {
    name: 'English (Canada)',
    value: LanguageLocaleKey.EN_CA,
    flagClassNames: 'flag-icon flag-icon-ca',
    icon: '/assets/images/flags/ca.svg',
    firstDayOfTheWeek: 0,
  },
  {
    name: 'English (GB)',
    value: LanguageLocaleKey.EN_GB,
    flagClassNames: 'flag-icon flag-icon-gb',
    icon: '/assets/images/flags/gb.svg',
    firstDayOfTheWeek: 1,
  },
  {
    name: 'English (US)',
    value: LanguageLocaleKey.EN_US,
    flagClassNames: 'flag-icon flag-icon-us',
    icon: '/assets/images/flags/us.svg',
    firstDayOfTheWeek: 0,
  },
  {
    name: 'Français (Canada)',
    value: LanguageLocaleKey.FR_CA,
    flagClassNames: 'flag-icon flag-icon-ca',
    icon: '/assets/images/flags/ca.svg',
    firstDayOfTheWeek: 0,
  },
  {
    name: 'Español',
    value: LanguageLocaleKey.ES,
    flagClassNames: 'flag-icon flag-icon-es',
    icon: '/assets/images/flags/es.svg',
    firstDayOfTheWeek: 0,
  },
  {
    name: '日本語',
    value: LanguageLocaleKey.JA_JP,
    flagClassNames: 'flag-icon flag-icon-jp',
    icon: '/assets/images/flags/jp.svg',
    firstDayOfTheWeek: 0,
  },
  {
    name: '简体中文',
    value: LanguageLocaleKey.ZH_CN,
    flagClassNames: 'flag-icon flag-icon-CN',
    icon: '/assets/images/flags/cn.svg',
    firstDayOfTheWeek: 0,
  },
];

export default languages;
